import React, { useState, useEffect } from "react";
import { db } from "../db";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrency } from "../components/Redux/Slices/currencySlice";
import DeleteModal from "../components/DeleteModal";
import "../assets/styles/main.css";
import ExpenseLists from "../components/ExpenseLists";
 import ErrorSuccessMessage from "../components/ErrorSuccessMessage";

export default function DetailsScreen() {
  const [expenses, setExpenses] = useState([]);
  const navigate = useNavigate();
  const [activeRow, setActiveRow] = useState(null);
  // const [setCategoryExpenses] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { category } = useParams();
  const [expenseToDelete, setExpenseToDelete] = useState(null);
  const selectedCurrency = useSelector(selectCurrency);
  const categoryId = parseInt(category);
  const handleDelete = async (id) => {
    setShowDeleteModal(true);
    setExpenseToDelete(id);
  };
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [progress, setProgress] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const confirmDelete = async () => {
    try {
      await db.expenses.delete(expenseToDelete);
      const updatedExpenses = expenses.filter(
        (expense) => expense.id !== expenseToDelete
      );
      setExpenses(updatedExpenses);
      // setCategoryExpenses(updateCategoryExpenses(updatedExpenses));
    } catch (error) {
      console.error("Error deleting expense:", error);
    }
    setMessage("Successfully Deleted");
    setMessageType("success");
    startCountdown();
    setTimeout(() => {
      setMessage("");
      setMessageType("");
    }, 1000);
    setShowDeleteModal(false);
  };

  const handleEdit = async (id) => {
    try {
      localStorage.setItem("activeRow-detailsScreen", id);
      navigate(`/edit/${id}`);
    } catch (error) {
      console.error("Error editing expense:", error);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setExpenseToDelete(null);
  };

  const setActive = (id) => {
    const newActiveRow = activeRow === id ? null : id;
    localStorage.setItem("activeRow-detailsScreen", newActiveRow);
    setActiveRow(newActiveRow);
  };

  useEffect(() => {
    const storedActiveRow = localStorage.getItem("activeRow-detailsScreen");
    if (storedActiveRow) {
      setActiveRow(parseInt(storedActiveRow));
    }
  }, []);

  window.onbeforeunload = function () {
    localStorage.removeItem("activeRow-detailsScreen");
  };

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const expensesFromDB = await db.expenses.toArray();
        setExpenses(expensesFromDB);
      } catch (error) {
        console.error("Error fetching expenses:", error);
      }
    };

    fetchExpenses();
  }, []);
  const filteredExpenses = expenses.filter((expense) => {
    if (isNaN(categoryId)) {
      return (
        (expense.category === null || isNaN(expense.category)) &&
        expense.isDeleted !== 1
      );
    } else {
      return expense.category === categoryId && expense.isDeleted !== 1;
    }
  });

  const [intervalId, setIntervalId] = useState(null);

  const startCountdown = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setIsActive(true);
    setProgress(0);

    let currentProgress = 0;
    const newIntervalId = setInterval(() => {
      currentProgress += 100 / (1 * 10);
      setProgress(currentProgress);
    }, 100);

    setIntervalId(newIntervalId);
  };

  return (
    <>
      <div className=" main-div container p-2  position-relative">
        <div className="display-center pb-4">
          <button
            className="btn verticalAlign position-absolute start-0 "
            onClick={() => {
              navigate(-1);
            }}
          >
            <span className="fs-1  material-symbols-outlined">
              chevron_backward
            </span>
          </button>
          <h3 className=" verticalAlign heading-txt">Expense Items </h3>
        </div>

        <div className="card child-div">
          <div className="pt-2">
            <ExpenseLists
              filteredExpenses={filteredExpenses}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              activeRow={activeRow}
              selectedCurrency={selectedCurrency}
              setActive={setActive}
            />
          </div>
          <div className="col  ">
            <DeleteModal
              isOpen={showDeleteModal}
              onCancel={cancelDelete}
              onConfirm={confirmDelete}
            />
          </div>
          <ErrorSuccessMessage
            message={message}
            messageType={messageType}
            isActive={isActive}
            progress={progress}
          />
        </div>
      </div>
    </>
  );
}
